import { Card, pn, Stack, ValidationErrors } from "@compass/core";
import {
  CustomFilterEntity,
  StudentFilter as StudentFilterModel,
  StudentReportServiceDetailReportBy,
  StudentReportServiceDetailRequest,
  StudentReportServiceDetailResource,
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { ServiceDetailReportBy } from "./ServiceDetailReportBy";
import { StudentServiceFilter } from "pages/students/student-services/StudentServiceFilter";
import { StudentFilter } from "pages/students/students/StudentFilter";

export const ServiceDetailRequest = (props: {
  initialized: boolean;
  request: StudentReportServiceDetailRequest;
  setRequest: (value: StudentReportServiceDetailRequest) => void;
  // globalCommonFilter: StudentFilterModel;
  // setGlobalCommonFilter: (value: StudentFilterModel) => void;
  validationErrors: ValidationErrors;
}) => {
  const [resource, setResource] = useState<StudentReportServiceDetailResource>({});

  useEffect(() => {
    if (props.initialized) {
      // ApiService.studentReports.getServiceDetailRequest().then((response) => {
      //   props.setRequest(response);
      // });

      ApiService.studentReports.getServiceDetailResource().then((response) => {
        setResource(response);
      });
    }
  }, [props.initialized]);

  return (
    <Stack spacing="lg">
      <ServiceDetailReportBy
        reportBy={props.request.reportBy || ({} as StudentReportServiceDetailReportBy)}
        setReportBy={(reportBy) =>
          props.setRequest(
            produce(props.request, (draft) => {
              draft.reportBy = reportBy;
            })
          )
        }
        resource={resource.reportBy || {}}
        validationErrors={props.validationErrors[pn<StudentReportServiceDetailRequest>("reportBy")] || {}}
      />

      <Card header="Filter By">
        <StudentServiceFilter
          hiddenEntities={[CustomFilterEntity.StudentEnrollment]}
          customFilters={props.request.customFilters || []}
          setCustomFilters={(filter) =>
            props.setRequest(
              produce(props.request, (draft) => {
                draft.customFilters = filter;
              })
            )
          }
          studentServicefilter={props.request.studentServiceFilter || {}}
          studentDemographicsFilter={props.request.studentFilter || {}}
          setStudentServiceFilter={(filter) =>
            props.setRequest(
              produce(props.request, (draft) => {
                draft.studentServiceFilter = filter;
              })
            )
          }
          setStudentDemographicFilter={(filter) =>
            props.setRequest(
              produce(props.request, (draft) => {
                draft.studentFilter = filter;
              })
            )
          }

        />
      </Card>
    </Stack>
  );
};
